.root {
  background-color: var(--color-ds-surface-card);
  border-color: var(--color-ds-border-card);
}

.root-strong {
  border-color: var(--color-ds-border-card-strong);
}

.root:has(:focus-visible) {
  outline-style: solid;
  outline-width: var(--outline-ds-width-focus-inset);
  outline-offset: var(--outline-ds-offset-focus-inset);
  outline-color: var(--color-ds-outline-text);
}

.root-selected {
  background-color: var(--color-ds-surface-card-selected);
  outline-style: solid;
  outline-width: var(--outline-ds-width-focus);
  outline-offset: var(--outline-ds-offset-selected);
  outline-color: var(--color-ds-action-primary);
}

.root-selected:has(:focus-visible) {
  outline-width: var(--outline-ds-width-focus-inset);
  outline-offset: var(--outline-ds-offset-focus-inset);
  outline-color: var(--color-ds-action-primary);
}

.root-error {
  border-color: var(--color-ds-border-danger-soft);
  box-shadow: var(--shadow-ds-danger-ring);
}

.title {
  color: var(--color-ds-content-primary);
}

.description {
  color: var(--color-ds-content-subtle);
}

.check {
  color: var(--color-ds-action-primary);
}

.check-hidden {
  visibility: hidden;
}
